import { inject, Injectable, Type } from '@angular/core';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';
import { FpCorrelationGraphMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/components/fp-correlation-graph-minimized/fp-correlation-graph-minimized.component';
import { FpCorrelationGraphComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/components/fp-correlation-graph/fp-correlation-graph.component';
import { FpCorrelationGraphActionType } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.actions';
import { FpCorrelationGraphStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.store';
import { Observable } from 'rxjs';

@Injectable()
export class FpCorrelationGraphConnectService implements IFpCorrelationTabConnectService {
  protected tabStore = inject(FpCorrelationGraphStore);
  public currentTab = FpCorrelationTabs.CorrelationGraph;

  public component: Type<unknown> = FpCorrelationGraphComponent;
  public minimizedComponent: Type<unknown> = FpCorrelationGraphMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpCorrelationTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationGraphActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationGraphActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
